export default {
  list: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/quotes`,
  },
  listQuickView: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/manual-insurances`,
  },
  detail: {
    method: "get",
    url: "/api/flight/v2/policies/:number",
  },
  listProduct: { method: "get", url: "/api/flight/v2/products" },
  listProductCategory: {
    method: "get",
    url: "/api/flight/v2/products/categories",
  },
  downloadAll: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/quotes/action/download`,
  },
  getPresign: { method: "post", url: "/api/flight/v2/documents" },
  getPresignPolicy: {
    method: "post",
    url: "/api/smartphone/v2/presigned/policies",
  },
};
